<template>
  <BaseNoticeItem>
    <template #head>
      <strong>{{ $t('Employer of record onboarding incomplete') }}</strong>
    </template>
    <template #body>
      <p>
        {{
          $t(
            'Your onboarding with :partnerName is not yet complete. Please complete onboarding to ensure payments to you can be processed.',
            { partnerName: complianceData.partner_name },
          )
        }}
      </p>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useTranslation } from '@/composables/translation'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
})

const { $t } = useTranslation()
</script>
